import React, { useEffect, useState } from "react";
import app from "./base";

export const AuthContext = React.createContext(null);

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [pending, setPending] = useState(false);

  useEffect(() => {
    setPending(true);
    app.auth().onAuthStateChanged(async (user) => {
      if (user) {
        const getUser = await app
          .firestore()
          .collection("users")
          .doc(user.uid)
          .get();
        setCurrentUser(getUser.data());
        setPending(false);
      } else {
        setPending(false);
      }
    });
  }, []);

  if (pending) {
    return <div class="loader"></div>;
  }

  return (
    <AuthContext.Provider
      value={{
        currentUser,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
